import { render, staticRenderFns } from "./rptcustomerkonsi.vue?vue&type=template&id=4d89af82"
import script from "./rptcustomerkonsi.vue?vue&type=script&lang=js"
export * from "./rptcustomerkonsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports